import React from 'react';
import PropTypes from 'prop-types';
import onClickOutside from 'react-onclickoutside';

import './styles.css';

class ChatDropdown extends React.Component {
  state = {
    recentChatTab: true,
  };

  clickHandler = e => {
    e.stopPropagation();
    this.props.toggleFunc('chat');
  };

  switchTab = e => {
    e.persist();
    e.nativeEvent.stopImmediatePropagation();
    e.stopPropagation();
    this.setState({
      recentChatTab: !this.state.recentChatTab,
    });
  };

  handleClickOutside = e => {
    this.props.toggleFunc('outsideChat');
  };

  render() {
    // const { chat, chatCounter } = this.props;

    // const subMenuStatus = this.props.toggled ? 'flex' : 'none';
    // const subMenuStyles = {
    //   display: subMenuStatus,
    // };

    return (
      <div className="chat-dropdown">
        <div
          id="open-jquery-chat"
          className="chat-dropdown__icon"
          onClick={() => {
            if (window.gbsChat.hasOwnProperty('notificationsPopup')) {
              window.gbsChat.notificationsPopup.toggle();
            }
          }}
        />

        {/*<div
          className="chat-dropdown__submenu ignore-react-onclickoutside"
          style={subMenuStyles}
        >
          <div className="chat-dropdown__submenu-controls">
            <button
              className={
                this.state.recentChatTab
                  ? 'chat-dropdown__submenu-control chat-dropdown__submenu-control--active'
                  : 'chat-dropdown__submenu-control'
              }
              onClick={this.switchTab}
            >
              Recent Chats
            </button>
            <button
              className={
                !this.state.recentChatTab
                  ? 'chat-dropdown__submenu-control chat-dropdown__submenu-control--active'
                  : 'chat-dropdown__submenu-control'
              }
              onClick={this.switchTab}
            >
              Talk to Recruiter
            </button>
          </div>
          <div className="chat-dropdown__submenu-content">
            {this.state.recentChatTab ? (
              <div className="chat-dropdown__submenu-recent-chats">
                <ul className="chat-dropdown__submenu-recent-chats-list">
                  {chat.recentChats.map((recentChat, index) => (
                    <li
                      className="chat-dropdown__submenu-recent-chats-list-item"
                      key={index}
                    >
                      <a
                        className="chat-dropdown__submenu-recent-chats-list-item-link"
                        href={recentChat.link}
                      >
                        <div className="chat-dropdown__submenu-recent-chats-list-item-avatar">
                          <div className="chat-dropdown__submenu-recent-chats-list-item-photo">
                            <img
                              src={recentChat.avatar}
                              alt={recentChat.name}
                              className="chat-dropdown__submenu-recent-chats-list-item-img"
                            />
                          </div>
                        </div>
                        <div className="chat-dropdown__submenu-recent-chats-list-item-content">
                          <h5 className="chat-dropdown__submenu-recent-chats-list-item-name">
                            {recentChat.name}
                          </h5>
                          <span className="chat-dropdown__submenu-recent-chats-list-item-subject">
                            {recentChat.subject}
                          </span>
                          <p className="chat-dropdown__submenu-recent-chats-list-item-text">
                            <EllipsisText text={recentChat.text} length={80} />
                          </p>
                        </div>
                        <span className="chat-dropdown__submenu-recent-chats-list-item-date">
                          {recentChat.date}
                        </span>
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ) : (
              <div className="chat-dropdown__submenu-recruiters">
                <ul className="chat-dropdown__submenu-recruiters-list">
                  {chat.recruiters.map((recruiter, index) => (
                    <li
                      className="chat-dropdown__submenu-recruiters-list-item"
                      key={index}
                    >
                      <a
                        className="chat-dropdown__submenu-recruiters-list-item-link"
                        href={recruiter.link}
                      >
                        <div className="chat-dropdown__submenu-recruiters-list-item-avatar">
                          <div className="chat-dropdown__submenu-recruiters-list-item-photo">
                            <img
                              src={recruiter.avatar}
                              alt={recruiter.name}
                              className="chat-dropdown__submenu-recruiters-list-item-img"
                            />
                          </div>
                        </div>

                        <h5 className="chat-dropdown__submenu-recruiters-list-item-name">
                          {recruiter.name}
                        </h5>
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>*/}
        {!!window.gbsChatCounter && (
          <span className="chat-dropdown__counter">
            {window.gbsChatCounter}
          </span>
        )}
      </div>
    );
  }
}

ChatDropdown.propTypes = {
  // chat: PropTypes.object.isRequired,
  // chatCounter: PropTypes.number,
  toggled: PropTypes.bool.isRequired,
  toggleFunc: PropTypes.func.isRequired,
};

export default onClickOutside(ChatDropdown);
